<template>
  <template v-for="field in fields" :key="field.key">
    <label
      v-if="field.config.type === 'checkbox'"
      :for="`sfi-${field.key}`"
      class="archive__subscribe-form-label"
    >
      <input
        :id="`sfi-${field.key}`"
        type="checkbox"
        :checked="!!metadata[field.key]"
        @change="handleInput(field.key, $event)"
      />
      <span>{{ field.label }}</span>
    </label>

    <template v-else-if="field.config.type === 'text'">
      <label
        :for="`sfi-${field.key}`"
        class="archive__subscribe-form-label sr-only"
      >
        {{ placeholder(field) }}
      </label>
      <input
        :id="`sfi-${field.key}`"
        :value="metadata[field.key]"
        type="text"
        :required="field.config.required"
        :placeholder="placeholder(field)"
        :autocomplete="AUTOCOMPLETE_ATTRIBUTES[field.key] || 'off'"
        @input="handleInput(field.key, $event)"
      />
    </template>

    <template v-else-if="field.config.type === 'select'">
      <label
        :for="`sfi-${field.key}`"
        class="archive__subscribe-form-label sr-only"
      >
        {{ placeholder(field) }}
      </label>
      <select
        :id="`sfi-${field.key}`"
        :value="metadata[field.key]"
        :required="field.config.required"
        @input="handleInput(field.key, $event)"
      >
        <option value="" :disabled="field.config.required" selected>
          {{ placeholder(field) }}
        </option>
        <option
          v-for="(option, i) in field.config.options"
          :key="i"
          :value="option.id"
        >
          {{ option.label }}
        </option>
      </select>
    </template>
  </template>
</template>

<script setup lang="ts">
import type { Newsletter } from "@/types/newsletter";

type AutonomyField = Newsletter["autonomy_fields"][number];

const AUTOCOMPLETE_ATTRIBUTES: Record<string, string> = {
  first_name: "given-name",
  last_name: "family-name",
  name: "name",
};

const props = defineProps<{
  fields: AutonomyField[];
  metadata: Record<string, string>;
}>();

const emit = defineEmits<{
  "update:metadata": [value: Record<string, string>];
}>();

function placeholder(field: AutonomyField): string {
  const required = "required" in field.config && field.config.required;
  return `${field.label}${required ? "*" : ""}`;
}

function handleInput(key: string, event: Event) {
  const el = event.target as HTMLInputElement;
  const value = el.type === "checkbox" ? (el.checked ? "on" : "") : el.value;
  emit("update:metadata", { ...props.metadata, [key]: value });
}
</script>
